import { Container } from 'unstated-typescript'
import { ErrorMessages, getCameraSnapshot, getWebRTCConnection } from '../api/backstaige_v2'
import {
  RemoteParticipant,
  RemoteTrack,
  RemoteTrackPublication,
  Room,
  RoomEvent,
  Track
} from 'livekit-client'

export type LivekitState = {
  connected: boolean
  livekit?: { url: string; token: string }
  element?: HTMLMediaElement
  urlElement?: string
  room: any
}

export class LivekitContainer extends Container<LivekitState> {
  constructor() {
    super()
    this.state = {
      connected: false,
      livekit: undefined,
      element: undefined,
      urlElement: undefined,
      room: undefined
    }
  }

  setReset() {
    this.setState({
      connected: false,
      livekit: undefined,
      element: undefined,
      urlElement: undefined
    })
  }

  getSnapshot = async (cameraId: string) => {
    const img = (await getCameraSnapshot(cameraId)) as string
    this.setState({
      urlElement: img,
      connected: true
    })
  }

  livekitConnectionStart = async (cameraId: string) => {
    await getWebRTCConnection(cameraId)
      .then((res) => {
        if ('serverUrl' in res) {
          this.livekitConnectToRoom(res.serverUrl, res.userToken)
        }
      })
      .catch((err) => {
        const data = err.response.data
        if ('error' in data && data.message === ErrorMessages.RecorderIsRunning) {
          this.getSnapshot(cameraId)
        } else {
          console.error('Failed to get WebRTC connection')
        }
      })
  }

  cleaningState = () => {
    if (this.state.element) {
      this.state.element.srcObject = null
      this.state.element.remove()
    }
    if (this.state.room) {
      this.state.room.disconnect()
      this.state.room = undefined
    }
    this.setState({
      connected: false,
      element: undefined,
      urlElement: undefined,
      livekit: undefined
    })
  }

  livekitConnectToRoom = async (url: string, token: string) => {
    const handleTrackSubscribed = (
      track: RemoteTrack,
      publication: RemoteTrackPublication,
      participant: RemoteParticipant
    ) => {
      console.log('track', track.kind)

      if (track.kind === Track.Kind.Video) {
        const videoEl = track.attach() as HTMLVideoElement
        videoEl.id = 'cameraCam'
        videoEl.autoplay = true
        videoEl.playsInline = true

        this.setState({
          element: videoEl,
          connected: true,
          livekit: { url, token }
        })
      }

      if (track.kind === Track.Kind.Audio) {
        const audioEl = track.attach() as HTMLAudioElement
        audioEl.autoplay = true
        //audioEl.playsInline = true
        audioEl.muted = false
      }
    }

    const handleTrackUnsubscribed = (
      track: RemoteTrack,
      publication: RemoteTrackPublication,
      participant: RemoteParticipant
    ) => {
      track.detach()
      this.setState({
        connected: false
      })
    }

    const handleDisconnect = () => {
      this.setState({
        connected: false
      })
    }

    if (url && token) {
      try {
        const room = new Room({})
        room.prepareConnection(url, token)
        room
          .on(RoomEvent.TrackSubscribed, handleTrackSubscribed)
          .on(RoomEvent.TrackUnsubscribed, handleTrackUnsubscribed)
          .on(RoomEvent.Disconnected, handleDisconnect)

        await room.connect(url, token)

        this.setState({
          room: room
        })
      } catch (error) {
        console.error('Failed to connect to LiveKit', error)
      }
    }
  }
}

const webRTCContainer = new LivekitContainer()
export default webRTCContainer
